var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKeySolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.516 12a1.5 1.5 0 1 1-.001-2.999A1.5 1.5 0 0 1 10.516 12m5.164.79c.125-.411.273-.839.273-1.29 0-2.485-1.983-4.5-4.468-4.5A4.487 4.487 0 0 0 7 11.5c0 2.485 2.023 4.5 4.508 4.5.451 0 .758-.087 1.168-.21l.09.21v2h2v2h2v2h2.25l1 1h2.75v-3z"
})));
export default SvgKeySolid;